@theme {
  --color-ember-50: var(--ember-50);
  --color-ember-100: var(--ember-100);
  --color-ember-150: var(--ember-150);
  --color-ember-200: var(--ember-200);
  --color-ember-250: var(--ember-250);
  --color-ember-300: var(--ember-300);
  --color-ember-350: var(--ember-350);
  --color-ember-400: var(--ember-400);
  --color-ember-450: var(--ember-450);
  --color-ember-500: var(--ember-500);
  --color-ember-550: var(--ember-550);
  --color-ember-600: var(--ember-600);
  --color-ember-650: var(--ember-650);
  --color-ember-700: var(--ember-700);
  --color-ember-750: var(--ember-750);
  --color-ember-800: var(--ember-800);
  --color-ember-850: var(--ember-850);
  --color-ember-900: var(--ember-900);
  --color-ember-950: var(--ember-950);
  --color-ember-1000: var(--ember-1000);
  --color-ember-1050: var(--ember-1050);
  --color-earthfire-50: var(--earthfire-50);
  --color-earthfire-100: var(--earthfire-100);
  --color-earthfire-150: var(--earthfire-150);
  --color-earthfire-200: var(--earthfire-200);
  --color-earthfire-250: var(--earthfire-250);
  --color-earthfire-300: var(--earthfire-300);
  --color-earthfire-350: var(--earthfire-350);
  --color-earthfire-400: var(--earthfire-400);
  --color-earthfire-450: var(--earthfire-450);
  --color-earthfire-500: var(--earthfire-500);
  --color-earthfire-550: var(--earthfire-550);
  --color-earthfire-600: var(--earthfire-600);
  --color-earthfire-650: var(--earthfire-650);
  --color-earthfire-700: var(--earthfire-700);
  --color-earthfire-750: var(--earthfire-750);
  --color-earthfire-800: var(--earthfire-800);
  --color-earthfire-850: var(--earthfire-850);
  --color-earthfire-900: var(--earthfire-900);
  --color-earthfire-950: var(--earthfire-950);
  --color-earthfire-1000: var(--earthfire-1000);
  --color-earthfire-1050: var(--earthfire-1050);
  --color-fuchsia-heat-50: var(--fuchsia-heat-50);
  --color-fuchsia-heat-100: var(--fuchsia-heat-100);
  --color-fuchsia-heat-150: var(--fuchsia-heat-150);
  --color-fuchsia-heat-200: var(--fuchsia-heat-200);
  --color-fuchsia-heat-250: var(--fuchsia-heat-250);
  --color-fuchsia-heat-300: var(--fuchsia-heat-300);
  --color-fuchsia-heat-350: var(--fuchsia-heat-350);
  --color-fuchsia-heat-400: var(--fuchsia-heat-400);
  --color-fuchsia-heat-450: var(--fuchsia-heat-450);
  --color-fuchsia-heat-500: var(--fuchsia-heat-500);
  --color-fuchsia-heat-550: var(--fuchsia-heat-550);
  --color-fuchsia-heat-600: var(--fuchsia-heat-600);
  --color-fuchsia-heat-650: var(--fuchsia-heat-650);
  --color-fuchsia-heat-700: var(--fuchsia-heat-700);
  --color-fuchsia-heat-750: var(--fuchsia-heat-750);
  --color-fuchsia-heat-800: var(--fuchsia-heat-800);
  --color-fuchsia-heat-850: var(--fuchsia-heat-850);
  --color-fuchsia-heat-900: var(--fuchsia-heat-900);
  --color-fuchsia-heat-950: var(--fuchsia-heat-950);
  --color-fuchsia-heat-1000: var(--fuchsia-heat-1000);
  --color-fuchsia-heat-1050: var(--fuchsia-heat-1050);
  --color-polar-glow-50: var(--polar-glow-50);
  --color-polar-glow-100: var(--polar-glow-100);
  --color-polar-glow-150: var(--polar-glow-150);
  --color-polar-glow-200: var(--polar-glow-200);
  --color-polar-glow-250: var(--polar-glow-250);
  --color-polar-glow-300: var(--polar-glow-300);
  --color-polar-glow-350: var(--polar-glow-350);
  --color-polar-glow-400: var(--polar-glow-400);
  --color-polar-glow-450: var(--polar-glow-450);
  --color-polar-glow-500: var(--polar-glow-500);
  --color-polar-glow-550: var(--polar-glow-550);
  --color-polar-glow-600: var(--polar-glow-600);
  --color-polar-glow-650: var(--polar-glow-650);
  --color-polar-glow-700: var(--polar-glow-700);
  --color-polar-glow-750: var(--polar-glow-750);
  --color-polar-glow-800: var(--polar-glow-800);
  --color-polar-glow-850: var(--polar-glow-850);
  --color-polar-glow-900: var(--polar-glow-900);
  --color-polar-glow-950: var(--polar-glow-950);
  --color-polar-glow-1000: var(--polar-glow-1000);
  --color-polar-glow-1050: var(--polar-glow-1050);
  --color-glacier-pool-50: var(--glacier-pool-50);
  --color-glacier-pool-100: var(--glacier-pool-100);
  --color-glacier-pool-150: var(--glacier-pool-150);
  --color-glacier-pool-200: var(--glacier-pool-200);
  --color-glacier-pool-250: var(--glacier-pool-250);
  --color-glacier-pool-300: var(--glacier-pool-300);
  --color-glacier-pool-350: var(--glacier-pool-350);
  --color-glacier-pool-400: var(--glacier-pool-400);
  --color-glacier-pool-450: var(--glacier-pool-450);
  --color-glacier-pool-500: var(--glacier-pool-500);
  --color-glacier-pool-550: var(--glacier-pool-550);
  --color-glacier-pool-600: var(--glacier-pool-600);
  --color-glacier-pool-650: var(--glacier-pool-650);
  --color-glacier-pool-700: var(--glacier-pool-700);
  --color-glacier-pool-750: var(--glacier-pool-750);
  --color-glacier-pool-800: var(--glacier-pool-800);
  --color-glacier-pool-850: var(--glacier-pool-850);
  --color-glacier-pool-900: var(--glacier-pool-900);
  --color-glacier-pool-950: var(--glacier-pool-950);
  --color-glacier-pool-1000: var(--glacier-pool-1000);
  --color-glacier-pool-1050: var(--glacier-pool-1050);
  --color-deep-current-50: var(--deep-current-50);
  --color-deep-current-100: var(--deep-current-100);
  --color-deep-current-150: var(--deep-current-150);
  --color-deep-current-200: var(--deep-current-200);
  --color-deep-current-250: var(--deep-current-250);
  --color-deep-current-300: var(--deep-current-300);
  --color-deep-current-350: var(--deep-current-350);
  --color-deep-current-400: var(--deep-current-400);
  --color-deep-current-450: var(--deep-current-450);
  --color-deep-current-500: var(--deep-current-500);
  --color-deep-current-550: var(--deep-current-550);
  --color-deep-current-600: var(--deep-current-600);
  --color-deep-current-650: var(--deep-current-650);
  --color-deep-current-700: var(--deep-current-700);
  --color-deep-current-750: var(--deep-current-750);
  --color-deep-current-800: var(--deep-current-800);
  --color-deep-current-850: var(--deep-current-850);
  --color-deep-current-900: var(--deep-current-900);
  --color-deep-current-950: var(--deep-current-950);
  --color-deep-current-1000: var(--deep-current-1000);
  --color-deep-current-1050: var(--deep-current-1050);
  --color-blue-red-50: var(--blue-red-50);
  --color-blue-red-100: var(--blue-red-100);
  --color-blue-red-150: var(--blue-red-150);
  --color-blue-red-200: var(--blue-red-200);
  --color-blue-red-250: var(--blue-red-250);
  --color-blue-red-300: var(--blue-red-300);
  --color-blue-red-350: var(--blue-red-350);
  --color-blue-red-400: var(--blue-red-400);
  --color-blue-red-450: var(--blue-red-450);
  --color-blue-red-500: var(--blue-red-500);
  --color-blue-red-550: var(--blue-red-550);
  --color-blue-red-600: var(--blue-red-600);
  --color-blue-red-650: var(--blue-red-650);
  --color-blue-red-700: var(--blue-red-700);
  --color-blue-red-750: var(--blue-red-750);
  --color-blue-red-800: var(--blue-red-800);
  --color-blue-red-850: var(--blue-red-850);
  --color-blue-red-900: var(--blue-red-900);
  --color-blue-red-950: var(--blue-red-950);
  --color-blue-red-1000: var(--blue-red-1000);
  --color-blue-orange-50: var(--blue-orange-50);
  --color-blue-orange-100: var(--blue-orange-100);
  --color-blue-orange-150: var(--blue-orange-150);
  --color-blue-orange-200: var(--blue-orange-200);
  --color-blue-orange-250: var(--blue-orange-250);
  --color-blue-orange-300: var(--blue-orange-300);
  --color-blue-orange-350: var(--blue-orange-350);
  --color-blue-orange-400: var(--blue-orange-400);
  --color-blue-orange-450: var(--blue-orange-450);
  --color-blue-orange-500: var(--blue-orange-500);
  --color-blue-orange-550: var(--blue-orange-550);
  --color-blue-orange-600: var(--blue-orange-600);
  --color-blue-orange-650: var(--blue-orange-650);
  --color-blue-orange-700: var(--blue-orange-700);
  --color-blue-orange-750: var(--blue-orange-750);
  --color-blue-orange-800: var(--blue-orange-800);
  --color-blue-orange-850: var(--blue-orange-850);
  --color-blue-orange-900: var(--blue-orange-900);
  --color-blue-orange-950: var(--blue-orange-950);
  --color-blue-orange-1000: var(--blue-orange-1000);
  --color-purple-yellow-50: var(--purple-yellow-50);
  --color-purple-yellow-100: var(--purple-yellow-100);
  --color-purple-yellow-150: var(--purple-yellow-150);
  --color-purple-yellow-200: var(--purple-yellow-200);
  --color-purple-yellow-250: var(--purple-yellow-250);
  --color-purple-yellow-300: var(--purple-yellow-300);
  --color-purple-yellow-350: var(--purple-yellow-350);
  --color-purple-yellow-400: var(--purple-yellow-400);
  --color-purple-yellow-450: var(--purple-yellow-450);
  --color-purple-yellow-500: var(--purple-yellow-500);
  --color-purple-yellow-550: var(--purple-yellow-550);
  --color-purple-yellow-600: var(--purple-yellow-600);
  --color-purple-yellow-650: var(--purple-yellow-650);
  --color-purple-yellow-700: var(--purple-yellow-700);
  --color-purple-yellow-750: var(--purple-yellow-750);
  --color-purple-yellow-800: var(--purple-yellow-800);
  --color-purple-yellow-850: var(--purple-yellow-850);
  --color-purple-yellow-900: var(--purple-yellow-900);
  --color-purple-yellow-950: var(--purple-yellow-950);
  --color-purple-yellow-1000: var(--purple-yellow-1000);
  --color-fuchsia-teal-50: var(--fuchsia-teal-50);
  --color-fuchsia-teal-100: var(--fuchsia-teal-100);
  --color-fuchsia-teal-150: var(--fuchsia-teal-150);
  --color-fuchsia-teal-200: var(--fuchsia-teal-200);
  --color-fuchsia-teal-250: var(--fuchsia-teal-250);
  --color-fuchsia-teal-300: var(--fuchsia-teal-300);
  --color-fuchsia-teal-350: var(--fuchsia-teal-350);
  --color-fuchsia-teal-400: var(--fuchsia-teal-400);
  --color-fuchsia-teal-450: var(--fuchsia-teal-450);
  --color-fuchsia-teal-500: var(--fuchsia-teal-500);
  --color-fuchsia-teal-550: var(--fuchsia-teal-550);
  --color-fuchsia-teal-600: var(--fuchsia-teal-600);
  --color-fuchsia-teal-650: var(--fuchsia-teal-650);
  --color-fuchsia-teal-700: var(--fuchsia-teal-700);
  --color-fuchsia-teal-750: var(--fuchsia-teal-750);
  --color-fuchsia-teal-800: var(--fuchsia-teal-800);
  --color-fuchsia-teal-850: var(--fuchsia-teal-850);
  --color-fuchsia-teal-900: var(--fuchsia-teal-900);
  --color-fuchsia-teal-950: var(--fuchsia-teal-950);
  --color-fuchsia-teal-1000: var(--fuchsia-teal-1000);
}

:root {
  --ember-50: #22272b;
  --ember-100: #1c2a3b;
  --ember-150: #1c2a4c;
  --ember-200: #25265c;
  --ember-250: #331f68;
  --ember-300: #441170;
  --ember-350: #611175;
  --ember-400: #800f73;
  --ember-450: #9f096a;
  --ember-500: #bc0758;
  --ember-550: #d7153a;
  --ember-600: #de2b34;
  --ember-650: #e43b2e;
  --ember-700: #e94927;
  --ember-750: #ee5621;
  --ember-800: #f3631b;
  --ember-850: #f77300;
  --ember-900: #f98200;
  --ember-950: #fb9100;
  --ember-1000: #fba000;
  --ember-1050: #faaf05;
  --earthfire-50: #523719;
  --earthfire-100: #5f360d;
  --earthfire-150: #6c3300;
  --earthfire-200: #7a2e00;
  --earthfire-250: #872600;
  --earthfire-300: #941b00;
  --earthfire-350: #a72a05;
  --earthfire-400: #b9380b;
  --earthfire-450: #cc4611;
  --earthfire-500: #e05516;
  --earthfire-550: #f3631b;
  --earthfire-600: #f77300;
  --earthfire-650: #f98200;
  --earthfire-700: #fb9100;
  --earthfire-750: #fba000;
  --earthfire-800: #faaf05;
  --earthfire-850: #fabb3b;
  --earthfire-900: #fac757;
  --earthfire-950: #fbd26f;
  --earthfire-1000: #fcdd85;
  --earthfire-1050: #fde79a;
  --fuchsia-heat-50: #65004d;
  --fuchsia-heat-100: #7b025f;
  --fuchsia-heat-150: #920472;
  --fuchsia-heat-200: #a90885;
  --fuchsia-heat-250: #c10d99;
  --fuchsia-heat-300: #d912ae;
  --fuchsia-heat-350: #e61e92;
  --fuchsia-heat-400: #f02d77;
  --fuchsia-heat-450: #f53e5b;
  --fuchsia-heat-500: #f6503e;
  --fuchsia-heat-550: #f3631b;
  --fuchsia-heat-600: #f77300;
  --fuchsia-heat-650: #f98200;
  --fuchsia-heat-700: #fb9100;
  --fuchsia-heat-750: #fba000;
  --fuchsia-heat-800: #faaf05;
  --fuchsia-heat-850: #fabb3b;
  --fuchsia-heat-900: #fac757;
  --fuchsia-heat-950: #fbd26f;
  --fuchsia-heat-1000: #fcdd85;
  --fuchsia-heat-1050: #fde79a;
  --polar-glow-50: #002664;
  --polar-glow-100: #013380;
  --polar-glow-150: #03419e;
  --polar-glow-200: #074fbd;
  --polar-glow-250: #0d5ddc;
  --polar-glow-300: #146cfd;
  --polar-glow-350: #0077e7;
  --polar-glow-400: #007ed0;
  --polar-glow-450: #0082b8;
  --polar-glow-500: #0082a2;
  --polar-glow-550: #2e808e;
  --polar-glow-600: #42929f;
  --polar-glow-650: #54a3b0;
  --polar-glow-700: #67b6c1;
  --polar-glow-750: #79c8d3;
  --polar-glow-800: #8cdbe5;
  --polar-glow-850: #9adfe5;
  --polar-glow-900: #a9e3e5;
  --polar-glow-950: #b6e7e6;
  --polar-glow-1000: #c4ebe7;
  --polar-glow-1050: #d1eeea;
  --glacier-pool-50: #441170;
  --glacier-pool-100: #511e88;
  --glacier-pool-150: #5d2ba1;
  --glacier-pool-200: #6a39bb;
  --glacier-pool-250: #7546d6;
  --glacier-pool-300: #8055f1;
  --glacier-pool-350: #7359f6;
  --glacier-pool-400: #645efa;
  --glacier-pool-450: #5362fc;
  --glacier-pool-500: #3c67fd;
  --glacier-pool-550: #146cfd;
  --glacier-pool-600: #0089ff;
  --glacier-pool-650: #0ca2ff;
  --glacier-pool-700: #3bb9ff;
  --glacier-pool-750: #64cdff;
  --glacier-pool-800: #8ce0ff;
  --glacier-pool-850: #9ae3ff;
  --glacier-pool-900: #a7e5ff;
  --glacier-pool-950: #b3e8fe;
  --glacier-pool-1000: #bfeafe;
  --glacier-pool-1050: #cbedfd;
  --deep-current-50: #0b3f47;
  --deep-current-100: #124b54;
  --deep-current-150: #195862;
  --deep-current-200: #206571;
  --deep-current-250: #27727f;
  --deep-current-300: #2e808e;
  --deep-current-350: #0082a2;
  --deep-current-400: #0082b8;
  --deep-current-450: #007ed0;
  --deep-current-500: #0077e7;
  --deep-current-550: #146cfd;
  --deep-current-600: #0089ff;
  --deep-current-650: #0ca2ff;
  --deep-current-700: #3bb9ff;
  --deep-current-750: #64cdff;
  --deep-current-800: #8ce0ff;
  --deep-current-850: #9ae3ff;
  --deep-current-900: #a7e5ff;
  --deep-current-950: #b3e8fe;
  --deep-current-1000: #bfeafe;
  --deep-current-1050: #cbedfd;
  --blue-red-50: #002664;
  --blue-red-100: #013380;
  --blue-red-150: #03419e;
  --blue-red-200: #074fbd;
  --blue-red-250: #0d5ddc;
  --blue-red-300: #146cfd;
  --blue-red-350: #4c8eff;
  --blue-red-400: #79acff;
  --blue-red-450: #a5c8ff;
  --blue-red-500: #d2e4ff;
  --blue-red-550: #fed7d6;
  --blue-red-600: #f9afae;
  --blue-red-650: #f18687;
  --blue-red-700: #e55961;
  --blue-red-750: #d7153a;
  --blue-red-800: #bf0f34;
  --blue-red-850: #a70a2d;
  --blue-red-900: #8f0527;
  --blue-red-950: #790220;
  --blue-red-1000: #630019;
  --blue-orange-50: #002664;
  --blue-orange-100: #013380;
  --blue-orange-150: #03419e;
  --blue-orange-200: #074fbd;
  --blue-orange-250: #0d5ddc;
  --blue-orange-300: #146cfd;
  --blue-orange-350: #4c8eff;
  --blue-orange-400: #79acff;
  --blue-orange-450: #a5c8ff;
  --blue-orange-500: #d2e4ff;
  --blue-orange-550: #ffe2d6;
  --blue-orange-600: #ffc4ad;
  --blue-orange-650: #fea683;
  --blue-orange-700: #fa8657;
  --blue-orange-750: #f3631b;
  --blue-orange-800: #e05516;
  --blue-orange-850: #cc4611;
  --blue-orange-900: #b9380b;
  --blue-orange-950: #a72a05;
  --blue-orange-1000: #941b00;
  --purple-yellow-50: #441170;
  --purple-yellow-100: #511e88;
  --purple-yellow-150: #5d2ba1;
  --purple-yellow-200: #6a39bb;
  --purple-yellow-250: #7546d6;
  --purple-yellow-300: #8055f1;
  --purple-yellow-350: #967bf7;
  --purple-yellow-400: #ae9efb;
  --purple-yellow-450: #c7bffe;
  --purple-yellow-500: #e3dfff;
  --purple-yellow-550: #fff0da;
  --purple-yellow-600: #ffe0b4;
  --purple-yellow-650: #fed08b;
  --purple-yellow-700: #fcc05d;
  --purple-yellow-750: #faaf05;
  --purple-yellow-800: #db9903;
  --purple-yellow-850: #bd8402;
  --purple-yellow-900: #a06f01;
  --purple-yellow-950: #845b00;
  --purple-yellow-1000: #694800;
  --fuchsia-teal-50: #65004d;
  --fuchsia-teal-100: #7b025f;
  --fuchsia-teal-150: #920472;
  --fuchsia-teal-200: #a90885;
  --fuchsia-teal-250: #c10d99;
  --fuchsia-teal-300: #d912ae;
  --fuchsia-teal-350: #e65bbf;
  --fuchsia-teal-400: #f088cf;
  --fuchsia-teal-450: #f8b1df;
  --fuchsia-teal-500: #fdd8ef;
  --fuchsia-teal-550: #d6e5e8;
  --fuchsia-teal-600: #aecbd1;
  --fuchsia-teal-650: #86b2ba;
  --fuchsia-teal-700: #5d99a4;
  --fuchsia-teal-750: #2e808e;
  --fuchsia-teal-800: #27727f;
  --fuchsia-teal-850: #206571;
  --fuchsia-teal-900: #195862;
  --fuchsia-teal-950: #124b54;
  --fuchsia-teal-1000: #0b3f47;
}
